export default __webpack_public_path__ + "static/media/Amazon-Elastic-Block-Store-EBS_light-bg.f7c2c2f0.svg";